function SiteFooter() {
  return (
    <footer className="shell-container pb-8 pt-6 sm:pb-10">
      <div className="section-frame flex flex-col gap-8 px-5 py-6 sm:px-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-xl">
            <p className="eyebrow">Technical Sandbox</p>
            <h2 className="mt-2 text-2xl font-semibold text-ink">
              Testing, Tooling, and Web Experiments.
            </h2>
            <p className="mt-3 text-sm leading-7 text-muted">
              A curated record of QA practice, technical investigation, and
              frontend-facing implementation work.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3 text-sm text-muted">
            <a
              href="https://www.linkedin.com/in/ypodonin/"
              target="_blank"
              rel="noopener noreferrer"
              className="secondary-button physical-button"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/ypodonin"
              target="_blank"
              rel="noopener noreferrer"
              className="secondary-button physical-button"
            >
              GitHub
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-line pt-5 text-sm text-muted sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {new Date().getFullYear()} Yaroslav Podonin. Technical Sandbox.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
